export default {
    data: () => ({
        translations: {
            title: {
                el: "Σάρωση Απόδειξης",
                en: "Scan Receipt",
                it: "Scansione Ricevuta"
            },
            info: {
                el: "Μόλις ενεργοποιηθεί, οι πελάτες σας θα μπορούν να σαρώσουν τις αποδείξεις από το κατάστημά σας.",
                en: `
                    Once activated, your customers will be able to scan the receipts
                    from your store.
                `,
                it: "Una volta attivato, i tuoi clienti potranno scansionare le ricevute dal tuo negozio."
            },
            telephone: {
                el: "Τηλέφωνο Επιχείρησης",
                en: "Business Telephone Number",
                it: "Numero di telefono dell'azienda"
            },
            vatNumber: {
                el: "ΑΦΜ",
                en: "Vat Number",
                it: "Partita IVA"
            },
            address: {
                el: "Διεύθυνση Επιχείρησης",
                en: "Business Address",
                it: "Recapito di Lavoro"
            },
            name: {
                el: "Επωνυμία Επιχείρησης",
                en: "Business Name",
                it: "Nome Commerciale"
            }
        }
    })
};
